import { Component, OnInit, AfterViewInit, ViewChild, Input, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { NgForm } from '@angular/forms';
import { StepDto, ValidationContent } from '../../../../models/StepDTO';
import { startWith } from 'rxjs/operators';

@Component({
  selector: 'wdm-supervisor-form',
  styleUrls: ['../../../../styles/components/steps.scss', 'supervisor-form.component.scss'],
  templateUrl: 'supervisor-form.component.html',
})
export class SupervisorFormComponent implements OnInit, AfterViewInit {

  @ViewChild('supervisorForm', { static: true }) private supervisorForm: NgForm;
  @Input() stepInfo: StepDto;
  @Output() errors: EventEmitter<boolean> = new EventEmitter<boolean>(true);

  constructor(
    private cd: ChangeDetectorRef
  ) { }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.supervisorForm.statusChanges?.pipe(
      startWith(this.supervisorForm.status) // Captura el estado inicial
    ).subscribe(status => {
      const isInvalid = status === 'INVALID';
      this.errors.emit(isInvalid);

      if (!isInvalid) {
        this.stepInfo.state = "OK";
      }
            this.cd.detectChanges();
    });
  }

  forceValidation() {
    // Marcamos todo como tocado para disparar los errores visuales
    Object.values(this.supervisorForm.controls).forEach(control => {
      control.markAsTouched();
    });
  }
}
